import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import DashboardLayout from "@/components/feature/DashboardLayout";
import AuthGuard from "@/components/feature/AuthGuard";
import LoginPage from "@/pages/auth/login/page";
import ForgotPasswordPage from "@/pages/auth/forgot-password/page";
import ResetPasswordPage from "@/pages/auth/reset-password/page";
import CallbackPage from "@/pages/auth/callback/page";
import SetupWizard from "@/pages/provider/setup/page";
import Dashboard from "@/pages/provider/dashboard/page";
import Orders from "@/pages/provider/orders/page";
import OrderDetailPage from "@/pages/provider/orders/detail/page";
import InvoicePage from "@/pages/provider/orders/invoice/page";
import Services from "@/pages/provider/services/page";
import Team from "@/pages/provider/team/page";
import ProviderUsers from "@/pages/provider/users/page";
import Reviews from "@/pages/provider/reviews/page";
import Reports from "@/pages/provider/reports/page";
import SalesReports from "@/pages/provider/sales-reports/page";
import Settlements from "@/pages/provider/settlements/page";
import SettlementDetailPage from "@/pages/provider/settlements/detail/page";
import Coverage from "@/pages/provider/coverage/page";
import Settings from "@/pages/provider/settings/page";
import Support from "@/pages/provider/support/page";
import Notifications from "@/pages/provider/notifications/page";
import TicketDetailPage from "@/pages/provider/support/detail/page";
import WithdrawPage from "@/pages/provider/settlements/withdraw/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/provider/dashboard" replace />,
  },
  { path: "/auth/login", element: <LoginPage /> },
  { path: "/auth/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/auth/reset-password", element: <ResetPasswordPage /> },
  { path: "/auth/callback", element: <CallbackPage /> },
  {
    path: "/provider",
    element: <AuthGuard />,
    children: [
      { path: "setup", element: <SetupWizard /> },
      {
        element: <DashboardLayout />,
        children: [
          { path: "dashboard", element: <Dashboard /> },
          { path: "orders", element: <Orders /> },
          { path: "orders/:id", element: <OrderDetailPage /> },
          { path: "orders/:id/invoice", element: <InvoicePage /> },
          { path: "services", element: <Services /> },
          { path: "team", element: <Team /> },
          { path: "users", element: <ProviderUsers /> },
          { path: "reviews", element: <Reviews /> },
          { path: "reports", element: <Reports /> },
          { path: "sales-reports", element: <SalesReports /> },
          { path: "settlements", element: <Settlements /> },
          { path: "settlements/:id", element: <SettlementDetailPage /> },
          { path: "settlements/withdraw", element: <WithdrawPage /> },
          { path: "coverage", element: <Coverage /> },
          { path: "settings", element: <Settings /> },
          { path: "notifications", element: <Notifications /> },
          { path: "support", element: <Support /> },
          { path: "support/:ticketId", element: <TicketDetailPage /> },
          { path: "", element: <Navigate to="/provider/dashboard" replace /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;